import 'css-chunk:src/components/widgets/UploadModal/UploadModal.scss';export default {
  "UploadModal": "_UploadModal_1f80r_1",
  "button": "_button_1f80r_1",
  "left": "_left_1f80r_4"
};